import Icon from "@mdi/react";
import { mdiClockTimeThreeOutline, mdiMapMarkerOutline } from "@mdi/js";
import { When } from "./When";

export function Info({ when, where }: { when?: string, where?: string }) {
    if (!when && !where) return null;

    return <div className="info">
        {when && <p className="when"><Icon path={mdiClockTimeThreeOutline} size={1} /><When date={when} /></p>}
        {where && <p className="where"><Icon path={mdiMapMarkerOutline} size={1} />{where}</p>}
    </div>;
}
